<template>
  <div>
      <ul class="chat-sidebar-list">
            <li v-for="(contact,index) in contactList" :key="index">
                <a :class="{ 'router-link-exact-active router-link-active' : contact.id == selected.id}">
                     <base-dropdown class="chatProfileImg chatProfileSetting">
                        <div slot="title">
                            <img :src="require(`@/assets/images/${contact.img}`)" alt class="icon" />
                        </div>

                        <template>
                            <a href="#">
                               Navigate
                            </a>
                            <a href="#">
                               Block
                            </a>
                            <a href="#">
                               Block & Report
                            </a>
                        </template>
                    </base-dropdown>
                    <div class="chatProfileDesc" @click="selectedContact(contact)">
                          <h3>{{contact.name}}</h3>
                          <p>Three Ways To Get Travel Disco...</p>
                          <span>11:23 am</span>
                    </div>
                </a>
            </li>
      </ul>

  </div>
</template>



<script>
  export default {

      name: "group-chat-list",
      props: ['windowSize'],

      data() {
          return {
            selected:'',
            contactList:[
              {
                id:1,
                name:'Highzone AF',
                desc:'Is there any upcoming events?',
                time: '11:23 am',
                img: 'group-chat1.png',
              },
              {
                id:2,
                name:'Sand Ajah',
                desc:'Three Ways To Get Travel Disco...',
                time: '11:23 am',
                img: 'group-chat2.png',
              },
              
            ]

          }
      },

      methods: {
        profileImg(img){
          return '/img/'+img
        },

        selectedContact(data){
          this.selected=data;
          let url = this.$route.path;
          if(url=='/inbox' && this.windowSize>768){
            console.log("got inbox");
          } else {
            this.$router.push('/chat-details/'+data.id);
          }
        }

      },


  }
</script>
